// extracted by mini-css-extract-plugin
export default {"nameText":"nameText__rGAUM3","nameTextSmall":"nameTextSmall__OhUAZN","variantCount":"variantCount__cW4hBK"};